import type { SearchQueryStringParams } from '../../../common/constants/schemas/query-params';

export type SearchInputConfig = {
	/**
	 * The search query text from the URL. Defaults to empty string when not present,
	 * as empty queries are valid (e.g. product=confluence search).
	 */
	searchQuery: string;
	/**
	 * The original query text before auto-correction. Undefined when no correction has occurred.
	 */
	originalQuery: string | undefined;
};

export type GetSearchInputConfigArgs = {
	queryParams: SearchQueryStringParams;
};

export type GetSearchInputConfig = (args: GetSearchInputConfigArgs) => SearchInputConfig;

/**
 * Helper to map between URL params as used by FPS, and the internal search input config used to generate the search query. This is a pure function that should be easily testable, and will be used in the search query generator function.
 *
 * Later improvement: do not rely on queryParams as the input prop for the search query text, take a text and originalQuery prop directly.
 */
export const getSearchInputConfig: GetSearchInputConfig = ({ queryParams }) => {
	if (!queryParams) {
		return {
			searchQuery: '',
			originalQuery: undefined,
		};
	}

	const searchQuery = queryParams?.text ?? '';
	const originalQuery = queryParams?.originalQuery;

	return {
		searchQuery,
		originalQuery,
	};
};
